import axios from 'axios'
import Cookies from 'js-cookie'

export default axios.create({
  baseURL: '/api',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'token': '189A8984A14985019120519DD823DC6C0165',
  }
})


// WEBPACK FOOTER //
// ./src/services/api.js